export const deprecatedFilterKeys = [
  'hasDataExport',
  'targeting',
  'contextKindsEvaluated',
  'contextKindTargeted',
  'followerId',
  'hasExperiment',
  'codeReferences',
] as const;

export type DeprecatedFilterKey = (typeof deprecatedFilterKeys)[number];

export function isDeprecatedFilterKey(key: string): boolean {
  return deprecatedFilterKeys.includes(key as DeprecatedFilterKey);
}
